export enum OkType {
  Blank = 'blank',
  Top = 'top',
  Url = 'url',
  Form = 'form',
  List = 'list',
  Reboot = 'reboot',
}
